import React from 'react';
import { Statistics } from '../types';

interface StatisticsPanelProps {
  statistics: Statistics;
}

const StatisticsPanel: React.FC<StatisticsPanelProps> = ({ statistics }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4 mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">本月统计</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-green-600">{statistics.locked}</div>
          <div className="text-sm text-gray-600">🔒 锁住天数</div>
        </div>
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-red-600">{statistics.unlocked}</div>
          <div className="text-sm text-gray-600">🔑 解锁天数</div>
        </div>
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-yellow-600">{statistics.ruined}</div>
          <div className="text-sm text-gray-600">🔒🐍 次数</div>
        </div>
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-black">{statistics.orgasm}</div>
          <div className="text-sm text-gray-600">🐍🐳 次数</div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-purple-600">{statistics.current_locked_streak}</div>
          <div className="text-sm text-gray-600">当前连续锁住</div>
        </div>
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-indigo-600">{statistics.max_locked_streak}</div>
          <div className="text-sm text-gray-600">最长连续锁住</div>
        </div>
        <div className="bg-white rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-gray-600">{statistics.total}</div>
          <div className="text-sm text-gray-600">总记录天数</div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsPanel;